export default __webpack_public_path__ + "static/media/misc-books2-1920w.97da54b5.avif";